import { useContext } from "react";

import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";

import { useInvalidateFileDescriptorQuery } from "@/queries/query-file-descriptors";
import { ProjectContext } from "@/stores/project-provider";
import { ProjectFile } from "@/types/api-model-simple-names";

type RestartFileDescriptorArgs = {
  file: ProjectFile;
  ref: string;
};
export const useRestartFile = () => {
  const { id: projectId } = useContext(ProjectContext);
  const invalidateFileDescriptorQuery = useInvalidateFileDescriptorQuery();
  return useMutationWithErrorHandler(async ({ file, ref }: RestartFileDescriptorArgs) => {
    const { id } = file;
    await getRanaApiV1().FilesApi.projectFileRestart({
      projectId,
      path: id,
      ref,
    });

    invalidateFileDescriptorQuery(file.descriptorId);
  }, {});
};
